import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class BoutInviteAccepted extends Message
{
    handle()
    {
        EventBus.emit('match-invite-accepted', this.message);
    }
}
